module.exports = __webpack_public_path__ + "img/hub.d94abad1.jpg";